module.exports = __webpack_public_path__ + "img/CS-UL-I_Overview-Spare_4.2b1fa356.jpg";